
import { Card, Col, Form, Input, Row } from 'antd'
import { ButtonSubmit } from 'components/Common/Buttons';
import useEncriptRSAHook from 'hooks/useEncriptRSAHook';
import useSimpleCaptcha from 'hooks/useSimpleCaptcha';
import React, { useState } from 'react'
import useAuthRepo from 'services/repo/useAuthRepo';
import Constant from 'utils/Constants';
import CustomAlert from 'utils/CustomAlert';
import LocalStorageUtils from 'utils/LocalStorage';
import SessionStorageUtils from 'utils/SessionStorage';
import { dismissToast, errorToast, loadingToastId, successToast } from 'utils/Toast';

const propsFormItem = {
    validateTrigger: false,
}

export default function ChangePassword() {
    const { changePassword } = useAuthRepo(false)
    const [form] = Form.useForm()
    const init_field = {
        oldPassword: "",
        newPassword: "",
        confirmNewPassword: "",
    }
    const [dataField, setDataField] = useState(init_field)
    // const {
    //     captchaUI,
    //     generateCaptcha,
    //     isValid: isValidCaptcha,
    //     handleInputCaptchaChange,
    // } = useSimpleCaptcha();
    // const { getEncriptedText } = useEncriptRSAHook()
    const [isLoadingChangePassword, setIsLoadingChangePassword] = useState(false)


    // const doSave = async () => {
    //     setIsLoadingChangePassword(true)
    //     try {
    //         const userId = LocalStorageUtils.userId.get();
    //         const oldPassword = form.getFieldValue('oldPassword');
    //         const newPassword = form.getFieldValue('newPassword');
    //         const confirmNewPassword = form.getFieldValue('confirmNewPassword');
    //         // const oldPassword = await dataField.oldPassword
    //         // const newPassword = await dataField.newPassword

    //         if (!userId) throw new Error("User ID is missing.");

    //         if (oldPassword && newPassword) {
    //             const idToast = "SUBMIT"
    //             loadingToastId(Constant.message.savingData, idToast);
    //             const payload = {
    //                 oldPassword,
    //                 newPassword,
    //             }
    //             let response = await changePassword(payload);
    //             dismissToast(idToast)
    //             if (response?.isValid && response?.statusCode === 200) {
    //                 LocalStorageUtils.jwtToken.set(response?.data?.bearerToken)
    //                 SessionStorageUtils.currentJwtToken.set(response?.data?.bearerToken)
    //                 successToast("Password Successfully Changed.")
    //                 form.resetFields();
    //                 setDataField(init_field)
    //                 // generateCaptcha()
    //             }
    //         }
    //         setIsLoadingChangePassword(false)
    //     } catch (error) {
    //         errorToast(`Err change password. err: ${error}`)
    //         setIsLoadingChangePassword(false)
    //     }
    // }

    const doSave = async () => {
        setIsLoadingChangePassword(true);
        const idToast = "SUBMIT";
        try {

            debugger
            //const userId = LocalStorageUtils.userId.get();
            const userInfoRaw = localStorage.getItem("userInfo");
            const userInfo = userInfoRaw ? JSON.parse(userInfoRaw) : null;
            const userId = userInfo?.userId;
            if (!userId) throw new Error("User ID not found in local storage.");

            const oldPassword = form.getFieldValue('oldPassword');
            const newPassword = form.getFieldValue('newPassword');
            const confirmNewPassword = form.getFieldValue('confirmNewPassword');

            if (!userId) throw new Error("User ID is missing.");

            loadingToastId(Constant.message.savingData, idToast);

            const payload = {
                userId: userId,
                userPasswordOld: oldPassword,
                userPasswordNew: newPassword,
                userPasswordConfirm: confirmNewPassword
            };

            console.log("payload dikirim:", payload);

            const response = await changePassword(payload);
            dismissToast(idToast);

            if(response?.detail=='OK' && response?.status === 200) {
                successToast("Password successfully changed.");
                form.resetFields();
            } else {
                errorToast("Failed to change password. Please check your input.");
            }

        } catch (error) {
            dismissToast(idToast);
            errorToast(`Error changing password: ${error.message}`);
        } finally {
            setIsLoadingChangePassword(false);
        }
    };


    const onFinish = async (values) => {
        CustomAlert.confirm({
            title: "Save Changes!",
            description: `Are you sure you want to save this data?`,
            confirmButtonText: "Save",
            type: "primary",
            onConfirmButton: () => doSave()
        });
    };

    return (
        <div className='container-change-password'>
            <Form
                name="form-change-password"
                form={form}
                layout='vertical'
                onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Card>
                    <Row>
                        <Col xs={24} sm={12}>
                            <Form.Item
                                {...propsFormItem}
                                name="oldPassword"
                                label="Old Password"
                                rules={[{ required: true }]}
                            >
                                <Input.Password
                                    placeholder='Old Password'
                                    onChange={(e) => {
                                        setDataField((prev) => ({
                                            ...prev,
                                            oldPassword: e.target.value
                                        }))
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} sm={12}>
                            <Form.Item
                                {...propsFormItem}
                                name="newPassword"
                                label="New Password"
                                rules={[{ required: true }]}
                            >
                                <Input.Password
                                    placeholder='New Password'
                                    onChange={(e) => {
                                        setDataField((prev) => ({
                                            ...prev,
                                            newPassword: e.target.value
                                        }))
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} sm={12}>
                            <Form.Item
                                {...propsFormItem}
                                name="confirmNewPassword"
                                label="Confirm New Password"
                                rules={[
                                    { required: true },
                                    {
                                        validator: (_, value) => {
                                            if (value !== dataField.newPassword) {
                                                return Promise.reject(new Error("Confirm New Password doesn't match with New Password."));
                                            } else {
                                                return Promise.resolve();
                                            }
                                        }
                                    }
                                ]}
                            >
                                <Input.Password
                                    placeholder='Confirm New Password'
                                    onChange={(e) => {
                                        setDataField((prev) => ({
                                            ...prev,
                                            confirmNewPassword: e.target.value
                                        }))
                                    }}
                                />
{/* 
                                <Input
                                    placeholder='Confirm New Password'
                                    onChange={(e) => {
                                        setDataField((prev) => ({
                                            ...prev,
                                            confirmNewPassword: e.target.value
                                        }))
                                    }}
                                /> */}
                            </Form.Item>
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col xs={24} sm={12}>
                            <Form.Item
                                {...propsFormItem}>
                                {captchaUI}
                            </Form.Item>
                            <Form.Item
                                {...propsFormItem}
                                name="captcha"
                                rules={[
                                    {
                                        validator: (_, value) => {
                                            if (!isValidCaptcha) {
                                                return Promise.reject(new Error('Invalid Captcha!'));
                                            } else {
                                                return Promise.resolve();
                                            }
                                        }
                                    }
                                ]}
                            >
                                <Input placeholder='Captcha' onChange={(e) => {
                                    setDataField((prev) => ({
                                        ...prev,
                                        captcha: e.target.value
                                    }))
                                    handleInputCaptchaChange(e.target.value)
                                }} />
                            </Form.Item>
                        </Col>
                    </Row> */}
                    <Row>
                        <Col xs={24} sm={12}>
                            <ButtonSubmit
                                loading={isLoadingChangePassword}
                                buttonText='Save' />
                        </Col>
                    </Row>
                </Card>
            </Form>
        </div>
    )
}
